module.exports = __webpack_public_path__ + "img/accuracy_report.4ce5201f.png";